// Coverage UI S4 — read-only founder check for UX affordances.
//
// The REAL enforcement is server-side (RLS + is_strikza_admin() on
// every activation RPC); this only decides whether to SHOW the
// founder's inline "→ Activate" deep-link. Soft-fails to false (a
// non-admin never sees admin chrome, and could not act on it even
// if they did). No writes, no PII.

import { useEffect, useMemo, useState } from "react";
import { getBrowserClient } from "../supabase/browser.ts";

export function useIsAdmin(): boolean {
  const supabase = useMemo(() => getBrowserClient(), []);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data, error } = await (supabase.rpc as unknown as (
          fn: string,
        ) => Promise<{ data: unknown; error: unknown }>)(
          "is_strikza_admin",
        );
        if (!cancelled) setIsAdmin(!error && data === true);
      } catch {
        if (!cancelled) setIsAdmin(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [supabase]);

  return isAdmin;
}
